import React, { useRef, useEffect, useState } from 'react';

import LogoRow from "../../components/LogoRow";
import ProgressionRow from '../../components/ProgressionRow';
import OfferBox from '../../components/OfferBox';
import FormSectionTitle from '../../components/FormSectionTitle';
import BigButton from '../../components/BigButton';
import { THEME_COLORS, MEDIA_QUERIES } from '../../styles/theme';
import { ReactComponent as PointerIcon } from "../../static/images/pointer.svg";
import { ReactComponent as TempleIcon } from "../../static/images/bank.svg";
import { ReactComponent as LetterIcon } from "../../static/images/letter.svg";
import { ReactComponent as Telegram } from "../../static/images/telegram.svg";
import { FormContainer, InputWrapper, InputWrapperHalf, InputWrapperMatchSmall, InputWrapperSmall, } from '../../components/FormContainer/components';
import {
    SectionContainer,
    ButtonsContainer,
    SectionTitle,
    SectionText,
    AccordionContainer,
    FormTitle,
    InputBooleanContainer
} from './style';
import { TextInput } from '../../components/TextInput';
import { ENV_VARIABLES} from "../../envVariables";
import { ForniturePage, PersonalDataPage, RecapPaymentPage } from '../../i18n';
import { Accordion } from "../../components/Accordion";
import { InputBoolean } from '../../components/InputBoolean';
import { PAYMENT_RECAP_FIELD_NAMES } from '../../reducers/paymentRecap';
import { BottomSheet } from '../../components/BottomSheet';
import { BottomsheetTriggerTitle, BottomSheetHeaderText, BottomsheetTriggerContainer, BottomsheetTriggerSubTitle } from '../../components/BottomSheet/style';
import { Offer } from '../../components/Offer';
import { SubmitButton } from '../../components/Buttons';
import { ROUTES, VALIDATORS_TYPE, ERROR_TEXTS, PAYMENT_METHODS, INPUT_TYPES, SHIPMENT_METHODS } from '../../utils/constants';
import { fieldValidator } from '../../utils/fieldValidator';
import { googleAutocompleteAddress } from '../../utils/googleAutocompleteAddress';
import { TextInputHelperText } from '../../components/TextInput/TextInputHelperText';
import { CFPopup } from '../PersonalDataPage/CFPopup';
import { generateFiscalCode } from '../../utils/generateFiscalCode';
import { ChatCallContainer } from '../../components/ChatCallContainer';
import { adfSendEvent } from '../../tracking/adfSendEvent';
import { setTrackerScript } from '../../tracking/setTracker';
import { getTrackingInfoOffer } from '../../tracking/getTrackingInfoOffer';
import { getFullPlaceNameFromDescription, getToponimoFromAddress } from '../../utils/getToponimoFromAddress';
import { DataLayerContainerPaymentRecap} from "../../components/DataLayer";

export const RecapPayment = props => {
    const { offer } = props;
    const [isPopupFiscalCodeOpen, setIsPopupFiscalCodeOpen] = useState(false);
    const [dateOfBirthFiscalCode, setDateOfBirthFiscalCode] = useState('');
    const [placeOfBirthFiscalCode, setPlaceOfBirthFiscalCode] = useState('');
    const [genderFiscalCode, setGenderFiscalCode] = useState(true);

    const addressInputRef = useRef(null);
    let ChatVisible = true
    const ProductAklamioArray = ENV_VARIABLES.ProductAklamioArray
    if (offer.name.includes('VIVIpartner') || ProductAklamioArray.includes(offer.offerId))
    {
        ChatVisible = false
    }

    const onChangeTextFiscalCodePopup = (field, e) => {
        if (field === 'placeOfBirth') {
            setPlaceOfBirthFiscalCode(e)
        } else {
            setDateOfBirthFiscalCode(e)
        }
    }

    useEffect(() => {
        props.onChange(
            PAYMENT_RECAP_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)
        );

        googleAutocompleteAddress(
            addressInputRef,
            () => {
                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddress, '');
            },
            (result) => {
                const resultPlaceName = getToponimoFromAddress(result.address);
                if (resultPlaceName) {
                    props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, resultPlaceName.description);
                    props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, resultPlaceName.code);
                    props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddress, resultPlaceName.parsedAddress || '');
                } else {
                    props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddress, result.address || '');
                }

                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressNumber, result.addressNumber || '');
                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality, result.municipality || '');
                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvince, result.province || '');
                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressCap, result.postalCode || '');
            });
    }, []);

    useEffect(() => {
        if (offer.name) {
            setTrackerScript({ ...getTrackingInfoOffer(offer), trackName: 'vivigas|x|funnel|recapito-pagamento' });
        }
    }, [offer]);

    return (
        <React.Fragment>
            <div className="container" style={{ marginBottom: '200px' }}>
                <DataLayerContainerPaymentRecap {...props}/>
                <CFPopup
                    isOpened={isPopupFiscalCodeOpen}
                    closePopup={() => setIsPopupFiscalCodeOpen(false)}
                    dateOfBirth={dateOfBirthFiscalCode}
                    placeOfBirth={placeOfBirthFiscalCode}
                    onChangeText={onChangeTextFiscalCodePopup}
                    isGenderMale={genderFiscalCode}
                    onChangeGender={setGenderFiscalCode}
                    callback={() => {
                        const fiscalCode = generateFiscalCode({
                            gender: genderFiscalCode,
                            dateOfBirth: dateOfBirthFiscalCode,
                            placeOfBirth: placeOfBirthFiscalCode,
                            name: props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName],
                            surname: props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname],
                        });

                        if (fiscalCode) {
                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode, fiscalCode.code);
                        } else {
                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode, '');
                        }
                    }}
                />
                <div>
                    <pre> {JSON.stringify(props.offer.name)}</pre>
                </div>

                <ChatCallContainer
                    trackerChat={() => adfSendEvent('vivigas|x|funnel|recapito-pagamento|click_chat')()}
                    trackerCallMeClick={() => adfSendEvent("vivigas|x|funnel|recapito-pagamento|click_ti_chiamiamo_noi")()}
                    callMeSubmitTrackName="vivigas|x|funnel|recapito-pagamento|click_conferma"
                    isCallMeVisible={ChatVisible}
                />

                <LogoRow />

                <ProgressionRow backpath={ROUTES.supply} step={2} />

                <div className="row">
                    <div className="col col-xl-8">

                        <FormSectionTitle
                            title={PersonalDataPage.formTitle}
                            subtitle={PersonalDataPage.formSubtitle}
                            backpath={"/dati-personali"}
                        />

                        <FormSectionTitle
                            title={ForniturePage.formTitle}
                            subtitle={ForniturePage.formSubtitle}
                            backpath="/indirizzo-fornitura"
                        />

                        <FormSectionTitle
                            title={RecapPaymentPage.formTitle}
                            subtitle={RecapPaymentPage.formSubtitle}
                            isActive={true}
                        />

                        <SectionContainer>
                            <SectionTitle>La tua bolletta</SectionTitle>

                            {!props.offer.name.includes('VIVIpartner')&& (
                                <SectionText>Scegli la soluzione green per ricevere 6€ di sconto</SectionText>
                            )}
                            {props.offer.name.includes('VIVIpartner')&& (
                                <SectionText>Scegli la bolletta online: aiuti l’ambiente e ricevi uno sconto in bolletta*</SectionText>
                            )}

                            <ButtonsContainer>
                                <BigButton
                                    label="Bolletta digitale"
                                    marginBot="14px"
                                    isActive={props.form[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] === SHIPMENT_METHODS.digitalBill}
                                    onChange={() => props.onChange(
                                        PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill,
                                        SHIPMENT_METHODS.digitalBill
                                    )}
                                    icon={PointerIcon}
                                />
                                {props.offer.name.includes('VIVIpartner')&& (
                                <BigButton
                                    label="Bolletta cartacea"
                                    marginBot="14px"
                                    isActive={props.form[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] === SHIPMENT_METHODS.paperBill}
                                    onChange={() => props.onChange(
                                        PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill,
                                        SHIPMENT_METHODS.paperBill,
                                    )}
                                    icon={Telegram}
                                />
                                )}
                            </ButtonsContainer>
                            {/* Display Paper Bill optional fields */}
                            <FormContainer
                                onSubmit={e => e.preventDefault()}
                                autoComplete="off"
                                style={{ display: props.form[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] === SHIPMENT_METHODS.paperBill ? 'flex' : 'none' }}
                            >
                                <InputBooleanContainer hasNoMargin={true}>
                                    <InputBoolean
                                        type="checkbox"
                                        label="Voglio ricevere le comunicazioni di VIVIgas energia all’indirizzo di fornitura"
                                        isChecked={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]}
                                        onChange={() => props.onChange(
                                            PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress,
                                            !props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]
                                        )}
                                    />
                                </InputBooleanContainer>

                                <FormTitle style={{ width: '100%' }} isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]}>Indicaci l’indirizzo al quale vuoi ricevere le informazioni scritte relative alla tua fornitura</FormTitle>
                                <InputWrapperSmall isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]}>
                                    <TextInput
                                        labelText="Piazza*"
                                        type={INPUT_TYPES.selectEditable}
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]}
                                        onValueChange={e => {
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, e);
                                            props.addressPlaceNameFilter(e);
                                        }}
                                        error={
                                            props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError]
                                            || props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCodeError]
                                        }
                                        onFocus={() => {
                                            props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError);
                                            props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCodeError);
                                            props.addressPlaceNameFilter(props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]);
                                        }}
                                        options={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameOptions]}
                                        onSelectOption={option => {
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, option.TOP_DESCRIZIONE_BREVE);
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.addressPlaceNameCode, option.TOP_TOPONIMO_COD);
                                            props.addressPlaceNameFilter('');
                                        }}
                                        onBlurValidator={() => {
                                            if (!props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]) return;
                                            const result = getFullPlaceNameFromDescription(
                                                props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText],
                                            );
                                            if (!result) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError, 'Toponimo non valido');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, '');
                                            } else {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, result.TOP_TOPONIMO_COD);
                                            }
                                        }}
                                        optionsExtractText={o => o.TOP_DESCRIZIONE_BREVE}
                                        optionsExtractKey={o => o.TOP_TOPONIMO_COD}
                                    />
                                </InputWrapperSmall>
                                <InputWrapperMatchSmall isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Indirizzo*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddress]}
                                        onValueChange={e => {
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddress, e);
                                            if (e.length === 0) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressNumber, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressCap, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvince, '');
                                            }
                                        }}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressError)}
                                        ref={addressInputRef}
                                        validator={VALIDATORS_TYPE.noValidation}
                                        hasLeftPadding={true}
                                    />
                                </InputWrapperMatchSmall>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Numero civico*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressNumber]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressNumber, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressNumberError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressNumberError)}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Suffisso*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix, e)}
                                        validator={VALIDATORS_TYPE.suffixLength}
                                    />
                                </InputWrapperHalf>
                                <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Comune*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipalityError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipalityError)}
                                    />
                                </InputWrapper>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="CAP*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressCap]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressCap, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressCapError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressCapError)}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasBillSameAddress]}>
                                    <TextInput
                                        labelText="Provincia*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvince]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvince, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError)}
                                        editable={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality] && props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality].length > 0}
                                        onBlurValidator={() => {
                                            if (!fieldValidator(
                                                props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvince],
                                                VALIDATORS_TYPE.isProvinceValid
                                            )) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError, ERROR_TEXTS.validationError);
                                            }
                                        }}
                                    />
                                </InputWrapperHalf>
                            </FormContainer>
                            {/* Display Digital Bill optional fields */}
                            <FormContainer
                                onSubmit={e => e.preventDefault()}
                                autoComplete="off"
                                style={{ display: props.form[PAYMENT_RECAP_FIELD_NAMES.hasDigitalBill] === SHIPMENT_METHODS.digitalBill ? 'flex' : 'none' }}
                            >
                                <InputBooleanContainer hasNoMargin={!props.form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]}>
                                    <InputBoolean
                                        type="checkbox"
                                        label="Voglio ricevere la bolletta e tutte le comunicazioni alla email indicata nei dati personali."
                                        isChecked={props.form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]}
                                        onChange={() => props.onChange(
                                            PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame,
                                            !props.form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]
                                        )}
                                    />
                                </InputBooleanContainer>
                                <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Email*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillError)}
                                        validator={VALIDATORS_TYPE.noValidation}
                                        onBlurValidator={() => {
                                            if (!fieldValidator(props.form[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBill], VALIDATORS_TYPE.email)) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillError, ERROR_TEXTS.validationError);
                                            }
                                        }}
                                    />
                                </InputWrapper>
                                <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.isDigitalBillEmailSame]}>
                                    <TextInput
                                        labelText="Conferma email*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmation]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmation, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmationError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.emailDigitalBillConfirmationError)}
                                        validator={VALIDATORS_TYPE.noValidation}
                                    />
                                </InputWrapper>
                            </FormContainer>
                        </SectionContainer>

                        <SectionContainer>
                            <SectionTitle>Metodo di pagamento</SectionTitle>
                            {props.offer.name.includes('VIVIpartner')&& (
                                <SectionText>Scegli di addebitare la fattura per non avere più pensieri e ricevere uno sconto in bolletta**</SectionText>
                            )}
                            <ButtonsContainer>
                                <BigButton
                                    label="Addebito su conto corrente"
                                    isActive={props.form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount}
                                    onChange={() => props.onChange(
                                        PAYMENT_RECAP_FIELD_NAMES.paymentMethod,
                                        PAYMENT_METHODS.bankAccount
                                    )}
                                    icon={TempleIcon}
                                />
                                {props.offer.name.includes('VIVIpartner')&& (
                                <BigButton
                                    label="Bollettino"
                                    isActive={props.form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.postal}
                                    onChange={() => props.onChange(
                                        PAYMENT_RECAP_FIELD_NAMES.paymentMethod,
                                        PAYMENT_METHODS.postal
                                    )}
                                    icon={LetterIcon}
                                />
                                )}
                            </ButtonsContainer>

                            {/* Display postal code optional fields */}
                            <FormContainer
                                onSubmit={e => e.preventDefault()}
                                autoComplete="off"
                                style={{ display: props.form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.postal ? 'flex' : 'none' }}
                            >
                                <InputBooleanContainer hasNoMargin={true}>
                                    <InputBoolean
                                        type="checkbox"
                                        label="Voglio ricevere le comunicazioni di VIVIgas energia all’indirizzo di fornitura"
                                        isChecked={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]}
                                        onChange={() => props.onChange(
                                            PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress,
                                            !props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]
                                        )}
                                    />
                                </InputBooleanContainer>

                                <FormTitle style={{ width: '100%' }} isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]}>Indicaci l’indirizzo al quale vuoi ricevere le informazioni scritte relative alla tua fornitura</FormTitle>
                                <InputWrapperSmall isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]}>
                                    <TextInput
                                        labelText="Piazza*"
                                        type={INPUT_TYPES.selectEditable}
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]}
                                        onValueChange={e => {
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, e);
                                            props.addressPlaceNameFilter(e);
                                        }}
                                        error={
                                            props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError]
                                            || props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCodeError]
                                        }
                                        onFocus={() => {
                                            props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError);
                                            props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCodeError);
                                            props.addressPlaceNameFilter(props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]);
                                        }}
                                        options={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameOptions]}
                                        onSelectOption={option => {
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, option.TOP_DESCRIZIONE_BREVE);
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.addressPlaceNameCode, option.TOP_TOPONIMO_COD);
                                            props.addressPlaceNameFilter('');
                                        }}
                                        onBlurValidator={() => {
                                            if (!props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText]) return;
                                            const result = getFullPlaceNameFromDescription(
                                                props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText],
                                            );
                                            if (!result) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameTextError, 'Toponimo non valido');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, '');
                                            } else {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, result.TOP_TOPONIMO_COD);
                                            }
                                        }}
                                        optionsExtractText={o => o.TOP_DESCRIZIONE_BREVE}
                                        optionsExtractKey={o => o.TOP_TOPONIMO_COD}
                                    />
                                </InputWrapperSmall>
                                <InputWrapperMatchSmall isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Indirizzo*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddress]}
                                        onValueChange={e => {
                                            props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddress, e);
                                            if (e.length === 0) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameCode, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressPlaceNameText, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressNumber, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressCap, '');
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvince, '');
                                            }
                                        }}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressError)}
                                        ref={addressInputRef}
                                        validator={VALIDATORS_TYPE.noValidation}
                                        hasLeftPadding={true}
                                    />
                                </InputWrapperMatchSmall>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Numero civico*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressNumber]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressNumber, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressNumberError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressNumberError)}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Suffisso*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressSuffix, e)}
                                        validator={VALIDATORS_TYPE.suffixLength}
                                    />
                                </InputWrapperHalf>
                                <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Comune*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipalityError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipalityError)}
                                    />
                                </InputWrapper>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]} hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="CAP*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressCap]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressCap, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressCapError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressCapError)}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.hasPostalSameAddress]}>
                                    <TextInput
                                        labelText="Provincia*"
                                        value={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvince]}
                                        onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvince, e)}
                                        error={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError]}
                                        onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError)}
                                        editable={props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality] && props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressMunicipality].length > 0}
                                        onBlurValidator={() => {
                                            if (!fieldValidator(
                                                props.form[PAYMENT_RECAP_FIELD_NAMES.billAddressProvince],
                                                VALIDATORS_TYPE.isProvinceValid
                                            )) {
                                                props.onChange(PAYMENT_RECAP_FIELD_NAMES.billAddressProvinceError, ERROR_TEXTS.validationError);
                                            }
                                        }}
                                    />
                                </InputWrapperHalf>
                            </FormContainer>

                            {/* Display bank account optional fields */}
                            <section style={{ display: props.form[PAYMENT_RECAP_FIELD_NAMES.paymentMethod] === PAYMENT_METHODS.bankAccount ? 'block' : 'none' }}>
                                <FormContainer onSubmit={e => e.preventDefault()} autoComplete="off">
                                    <InputWrapper>
                                        <TextInput
                                            labelText="IBAN*"
                                            value={props.form[PAYMENT_RECAP_FIELD_NAMES.iban]}
                                            onValueChange={e => props.onChange(PAYMENT_RECAP_FIELD_NAMES.iban, e)}
                                            error={props.form[PAYMENT_RECAP_FIELD_NAMES.ibanError]}
                                            onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.ibanError)}
                                            validator={VALIDATORS_TYPE.noValidation}
                                            onBlurValidator={() => {
                                                if (!fieldValidator(props.form[PAYMENT_RECAP_FIELD_NAMES.iban], VALIDATORS_TYPE.iban)) {
                                                    props.onChange(PAYMENT_RECAP_FIELD_NAMES.ibanError, ERROR_TEXTS.validationError);
                                                }
                                            }}
                                        />
                                    </InputWrapper>
                                    <InputBooleanContainer hasNoMargin={true}>
                                        <InputBoolean
                                            type="checkbox"
                                            label="Il titolare del conto corrisponde al titolare della fattura."
                                            isChecked={props.form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]}
                                            onChange={() => props.onChange(
                                                PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame,
                                                !props.form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]
                                            )}
                                        />
                                    </InputBooleanContainer>

                                    <FormTitle style={{ width: '100%'}} isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]}>Indicaci i dati del titolare del conto corrente <br/><span style={{fontSize: '14px'}}>(NOTA: l’intestatario delle fornitura deve comunque essere cointestatario del C/C o avere potere di firma)</span></FormTitle>
                                    <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]} hasElementsToTheRight={true}>
                                        <TextInput
                                            labelText="Nome*"
                                            value={props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName]}
                                            onValueChange={e => props.onChange(
                                                PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName,
                                                e
                                            )}
                                            error={props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountNameError]}
                                            onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountNameError)}
                                        />
                                    </InputWrapper>
                                    <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]}>
                                        <TextInput
                                            labelText="Cognome*"
                                            value={props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname]}
                                            onValueChange={e => props.onChange(
                                                PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname,
                                                e
                                            )}
                                            error={props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurnameError]}
                                            onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurnameError)}
                                        />
                                    </InputWrapper>
                                    <InputWrapper isHidden={props.form[PAYMENT_RECAP_FIELD_NAMES.isOwnerBankAccountSame]} hasElementsToTheRight={true}>
                                        <TextInput
                                            labelText="Codice fiscale*"
                                            value={props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode]}
                                            onValueChange={e => props.onChange(
                                                PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCode,
                                                e
                                            )}
                                            error={props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCodeError]}
                                            onFocus={() => props.resetError(PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountFiscalCodeError)}
                                            HelperComponent={
                                                <div onClick={() => setIsPopupFiscalCodeOpen(true)} style={{
                                                    display:
                                                        props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountName].length > 0
                                                            && props.form[PAYMENT_RECAP_FIELD_NAMES.ownerBankAccountSurname].length > 0
                                                            ? 'block' : 'none'
                                                }}>
                                                    <div className="d-none d-md-block" >
                                                        <TextInputHelperText>Non ricordo il codice fiscale</TextInputHelperText>
                                                    </div>
                                                    <div className="d-md-none d-lg-none d-xl-none">
                                                        <TextInputHelperText>Non ricordo il c.f.</TextInputHelperText>
                                                    </div>
                                                </div>
                                            }
                                            validator={VALIDATORS_TYPE.noValidation}
                                        />
                                    </InputWrapper>
                                </FormContainer>
                            </section>
                        </SectionContainer>

                        <SubmitButton
                            mainColor={THEME_COLORS.blueViolet}
                            type="submit"
                            value="Prosegui"
                            disabled={props.form[PAYMENT_RECAP_FIELD_NAMES.isSubmittingForm]}
                            onClick={async e => {
                                //leggo il cookie di tc commander
                                let VivigasUIdCookie = document.cookie.replace(/(?:(?:^|.*;\s*)VivigasUId\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                                console.log('VivigasUId', VivigasUIdCookie)
                                e.preventDefault();
                                try {
                                    await props.validate();
                                    window.tC.event.confirmStep(this, {stepId: 'funnel_step4', user_id : `"${VivigasUIdCookie}"`})
                                    console.log('tCEvent-> confirmStep funnel_step4')
                                    props.history.push(ROUTES.consents);
                                } catch (error) {

                                }
                            }}
                            errorText={props.form[PAYMENT_RECAP_FIELD_NAMES.errorFormSubmission]}
                            onClickSaveAndContinueLater={async e => {
                                e.preventDefault();
                                try {
                                    await props.validate(false);
                                    window.tC.event.dropOffConDatiSaveAndResume();
                                    console.log('tCEvent-> dropOffConDatiSaveAndResume funnel_step4')
                                    //console.log(window.tC.event.dropOffConDatiSaveAndResume());


                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                            successText={props.form[PAYMENT_RECAP_FIELD_NAMES.successText]}
                        />

                        <AccordionContainer>
                            <Accordion />
                        </AccordionContainer>
                        {props.offer.name.includes('VIVIpartner')&& (
                            <SectionContainer style={{marginTop: '30px'}}>
                                <SectionText>* Lo sconto Bolletta digitale è pari a 6€/anno per singola fornitura fino al massimo di 12€/anno nel caso di VIVIpartner LuceGas</SectionText>
                                <SectionText>**Lo sconto Pagamento con addebito è pari a 9€/anno per singola fornitura fino al massimo di 18€/anno nel caso di VIVIpartner LuceGas</SectionText>
                            </SectionContainer>
                        )}
                    </div>
                    <div className=".d-xs-none .d-sm-none .d-md-none .d-lg-none col-xl-3">
                        <OfferBox {...props.offer} />
                    </div>
                </div>

            </div>
            <BottomSheet
                TriggerContent={
                    <BottomsheetTriggerContainer>
                        <div style={{ marginRight: '20px' }}>
                            <BottomsheetTriggerTitle>{props.offer.name}</BottomsheetTriggerTitle>
                            <BottomsheetTriggerSubTitle>VISUALIZZA I DETTAGLI</BottomsheetTriggerSubTitle>
                        </div>
                    </BottomsheetTriggerContainer>
                }
                HeaderContent={<BottomSheetHeaderText>CHIUDI I DETTAGLI</BottomSheetHeaderText>}
                backgroundColor="white"
                Content={<Offer {...offer} isMobile={true} />}
                maxExcludedScreenSize={MEDIA_QUERIES.desktop}
            />
        </React.Fragment>
    )
}